import React from 'react';
import BaseballCountBackground from './countBackground';
import BaseballCountAnimate from './countAnimate';

const BaseballCount = ({
  count,
  type,
  width = 26,
  height = 15,
  isMatch = false
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${width} ${height}`}
    >
      <BaseballCountBackground isMatch={isMatch} />
      <BaseballCountAnimate count={count} type={type} isMatch={isMatch} />
    </svg>
  );
};

export default BaseballCount;
